import { Injectable } from '@angular/core';
import { CampaignLinkedinCredential } from '../models/campaign/campaign-settings';
import { AuthService } from 'src/app/core/services/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class CampaignAccountsService {
  constructor(private authService: AuthService) {}

  canAccessAccount(account: CampaignLinkedinCredential): boolean {
    const { status, enable } = account || {};

    return status === 'ACTIVE' && !!enable && this.canAccessAccountPersonally(account);
  }

  canAccessAccountPersonally(account: CampaignLinkedinCredential): boolean {
    const allowTeamAccess = !!account?.allowTeamAccess;
    const isCurrentUserAccount = this.isCurrentUserAccount(account);

    return allowTeamAccess || isCurrentUserAccount;
  }

  isCurrentUserAccount(account: CampaignLinkedinCredential): boolean {
    const currentUserId = this.authService.getUserId();
    const accountUserId = account?.userId;

    return !!currentUserId && !!accountUserId && accountUserId === currentUserId;
  }
}
